export default __webpack_public_path__ + "static/media/logo.519dc370.svg";